<nb-card>
  <nb-card-header>
    Choose main customer to merge, the rest will be removed
  </nb-card-header>

  <nb-card-body>
    <ng2-smart-table [settings]="settings"
                     [source]="source"
                     (userRowSelect)="selectRecord($event, true, false)"
    >
    </ng2-smart-table>
  </nb-card-body>
</nb-card>
